import React, { Component } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "../../../../../utils/date";
import { wbDebounce } from "../../../../../utils/common";
import { withTranslation } from "react-i18next";
import CloseIcon from '@material-ui/icons/Close'
import { IconButton } from '@workboard/wobo-ui'
import { buildMitDayPickerProps } from './mitDateUtils';

class MitIntervalTargets extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	showStartDatePicker = () => {
		this.endDatePicker.hideDayPicker();
		this.startDatePicker.showDayPicker();
	};

	showEndDatePicker = () => {
		this.startDatePicker.hideDayPicker();
		this.endDatePicker.showDayPicker();
	};

	handleClickOutside = e => {
		if (
			!$(".dateShowPopup").is(e.target) &&
			$(".dateShowPopup").has(e.target).length === 0
		) {
			if (this.startDatePicker) this.startDatePicker.hideDayPicker();
			if (this.endDatePicker) this.endDatePicker.hideDayPicker();
		}
	};

	handleInputBlur = (e, i) => {
		if (e.target.value.trim() !== "") {
			const { nameError, targetError } = this.props.segmentError || {};
			if ((e.target.name == 'intervalName' && nameError) 
			|| (e.target.name == 'targetValue' && targetError)){
				this.props.updateSegmentsError(i);
			}
		}
	};

	render() {
		const { t } = this.props
		let { mitIndex, dateSegments, segmentError = {} } = this.props;
		let inputIndex1 = `${mitIndex}3`;
		let inputIndex2 = `${mitIndex}4`;
		const dayPickerProps = buildMitDayPickerProps(
			this.props.goalDetails,
			dateSegments,
			mitIndex,
		);
		let goalStartDateProps = { dayPickerProps };
		let goalEndDateProps = { dayPickerProps };
		const { nameError = false, targetError = false, startDateError = false, endDateError = false } = segmentError;
		return (
			<div className={"mit-interval-targets"} data-testid="mit-interval-targets">
				<div className="w100">
					<div
						className="inLineBlk aEStartDate left dateShowPopup"
						onClick={() => this.showStartDatePicker()}
					>
						<div className="aEStartIcon dateShowPopup" />
						<DayPickerInput
							ref={el => (this.startDatePicker = el)}
							format="MMM DD, YYYY"
							value={this.props.startDate}
							formatDate={formatDate}
							parseDate={parseDate}
							placeholder=""
							inputProps={{
								name: "goal_start_date",
								type: "text",
								tabIndex: `${mitIndex}1`,
								className: `${startDateError ? ' errorBorder ' : ''}`
							}}
							{...goalStartDateProps}
							onDayChange={selectedDay =>
								this.props.handleStartDateChange(selectedDay, mitIndex)
							}
						/>
						{ startDateError && 
							<div className={"krNameError"}>
								<i className={"icon icon-outline-error_outline-14px-red"}> </i>{" "}
							{t('Invalid date')}
							</div>
						}
					</div>
					<div className="inLineBlk left goalTotext">to</div>
					<div style={{ marginLeft: 15 }} className={"verticalTop inLineBlk"}>
						<input
							type="text"
							name="intervalName"
							className={`metric-lower-value ${nameError ? ' errorBorder ' : ''}`}
							data-testid="metric-lower-value"
							value={this.props.intervalName}
							placeholder={"Ex: Q1"}
							onChange={e =>
								wbDebounce(this.props.handleChange(e, mitIndex), 250)
							}
							onKeyUp={e => this.handleInputBlur(e, mitIndex)}
							onBlur={e => this.handleInputBlur(e, mitIndex)}
							autoComplete="off"
							tabIndex={inputIndex1}
							autoFocus={true}
						/>
						<br />
						{
							nameError &&
							<div className={`krNameError`}>
								<i className={"icon icon-outline-error_outline-14px-red"}> </i>
                &nbsp;{t('Add interval name')}
              </div>
						}
					</div>
					<div
						style={{ margin: "0 2px 0 15px" }}
						className={"verticalTop inLineBlk"}
					>
						<input
							type="text"
							name="targetValue"
							className={`metric-lower-value ${targetError ? ' errorBorder ' : ''}`}
							data-testid="metric-lower-value"
							value={this.props.targetValue}
							onChange={e => this.props.handleChange(e, mitIndex)}
							onKeyUp={e => this.handleInputBlur(e, mitIndex)}
							onBlur={e => this.handleInputBlur(e, mitIndex)}
							autoComplete="off"
							tabIndex={inputIndex2}
						/>
						<br />
						{ targetError &&
							<div
								className={`krNameError`}
								data-testid="krNameError"
							>
								<i className={"icon icon-outline-error_outline-14px-red"}> </i>
                &nbsp; {t('Add value')}
              </div>
						}
					</div>
					<div
						className={"child-kr-id hidden"}
						data-child-kr-id={this.props.krId}
					/>
					<div
						className="inLineBlk aEEndDate left dateShowPopup"
						onClick={() => this.showEndDatePicker()}
					>
						<div className="aEStartIcon dateShowPopup" />
						<DayPickerInput
							ref={el => (this.endDatePicker = el)}
							inputProps={{
								name: "goal_end_date",
								type: "text",
								tabIndex: `${mitIndex}2`,
								className: `${endDateError ? ' errorBorder ' : ''}`
							}}
							format="MMM DD, YYYY"
							value={this.props.endDate}
							formatDate={formatDate}
							parseDate={parseDate}
							placeholder=""
							{...goalEndDateProps}
							onDayChange={selectedDay =>
								this.props.handleEndDateChange(selectedDay, mitIndex)
							}
						/>
						{
							endDateError && 
							<div className={"krNameError"}>
								<i className={"icon icon-outline-error_outline-14px-red"}> </i>{" "}
								{t('Invalid date')}
							</div>
						}
					</div>
					{/* We dont need to show delete icon for first child KR. */}
					{(mitIndex > 0 && (this.props.mitType == "custom" || !this.props.isAnnualMit)) &&(
						  <IconButton
                className="close-icon"
                aria-label="delete interval"
                onClick={() => this.props.deleteInterval(mitIndex)}
              >
                <CloseIcon />
              </IconButton>
					)}
					<div className="clear" />
				</div>
				<div className={"clear"} />
			</div>
		);
	}
}

export default withTranslation()(MitIntervalTargets);
